export const profile = {
  name: "Priyanshu Jha",
  initials: "PJ",
  role: "MERN Stack Developer",
  location: "Tamil Nadu, India",
  email: "priyanshujha712003@gmail.com",
  phone: "+91-8340506515",
  github: "https://github.com/priyanshujha111",
  linkedin: "https://www.linkedin.com/in/priyanshu-jha-044474237/",
  summary:
    "MERN stack developer with 9 months of internship experience building full-stack applications and modern web solutions. Proficient in React.js, Next.js, Node.js, MongoDB, and PostgreSQL, with hands-on experience building responsive, scalable web applications. Seeking a Software Engineer role to contribute to impactful projects and build high-quality software.",
};
